import React, { useState } from 'react'
import { Link, useParams } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { Helmet } from 'react-helmet-async'
import { FaAnglesRight } from "react-icons/fa6";
import { GrHome } from "react-icons/gr";
import notFoundImg from '../../assets/img/scan.png';

import { faqData } from './HelpData'; 


const HelpInfoByCategory = () => {
  const { categoryID } = useParams();
  const categoryData = faqData.find(item => item.slug === categoryID);
  const category = categoryData?.title || '';
  const faqs = categoryData?.faqs || [];  

  const [openIndex, setOpenIndex] = useState(null);
  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <Helmet>
        <title>{category.toUpperCase()} Info Page | Cardplot</title>
      </Helmet>

      <section className='breadcrumb__section bg-overlay position-relative help-center-hero category-help-hero'>
        <div className="page__navigation" style={{ maxWidth: '1050px', margin: '0 auto' }}>
          <ul className='position-absolute top-0 d-flex align-items-center gap-2 p-2' style={{ zIndex: 2 }}>
            <li className='d-flex align-items-center gap-2'>
              <Link to='/' className='d-flex align-items-center gap-1'><GrHome /> Home</Link>
              <FaAnglesRight color='#210861' />
            </li>
            <li className='d-flex align-items-center gap-2'>
              <Link to='/help'>Help Center</Link>
              <FaAnglesRight color='#210861' />
            </li>
            <li className='d-flex align-items-center gap-2 text-capitalize'>
              {category}
            </li>
          </ul>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="breadcrumb__text">
                <h4 className='breadcrumb__text__head text-capitalize'>{category} Information</h4>
                <p className='breadcrumb__text__content color__blue size_pricing'>
                  Having a tough time? We can help!
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='help__center__section faq-list-section'>
            <div className='container mt-5'>
                <div className='row' style={{ paddingBottom: '90px' }}>
                    {faqs.length === 0 ? (
                        <div className="text-center w-100">
                            <img src={notFoundImg} alt="No articles" style={{ maxWidth: '150px', marginBottom: '20px' }} />
                            <h5 className="fw-bold">No article found under this topic</h5>
                        </div>
                    ) : (
                        faqs.map((faq, index) => (
                        <div key={index} className="help__center__section__button">
                            <button onClick={() => toggleAccordion(index)} className={`d-flex justify-content-between align-items-center text-left ${openIndex === index ? 'button-open' : ''}`} >
                                <span className="faq-question">{faq.question}</span>
                                <ChevronDown className={`chevron-down ${openIndex === index ? 'rotate-180' : ''}`} />
                            </button>
                            <div className={`accordion-content ${openIndex === index ? 'open' : 'closed'}`}>
                                <p className="whitespace-pre-line">{faq.answer}</p>
                            </div>
                        </div>
                        ))
                    )}
                </div>
            </div>
        </section>

    </>
  );
};

export default HelpInfoByCategory;
